import { Tool } from '@procureai/agents';
import { useTranslation } from 'react-i18next';

import { ChatLoadingIndicator } from '../ChatMessage/indicators/ChatLoadingIndicator';
import { ChatToolResultIndicator } from '../ChatMessage/indicators/ChatToolResultIndicator';
import {
  SvbrgSearchPurchaseRequisitionItemInput,
  SvbrgSearchPurchaseRequisitionItemOutput,
} from '@/generated/gql/graphql';
import { I18nNamespace } from '@/legacy/common/types';

import { ToolResultComponent } from '.';

export const PurchaseRequisitionItemTool: ToolResultComponent<
  Tool.searchPurchaseRequisitionItem,
  SvbrgSearchPurchaseRequisitionItemInput,
  SvbrgSearchPurchaseRequisitionItemOutput
> = ({ tool, toolName }) => {
  const { t } = useTranslation(I18nNamespace.intake, { keyPrefix: `Chat.tools.${toolName}` });

  switch (tool.state) {
    case 'input-streaming':
    case 'input-available':
      return (
        <ChatLoadingIndicator
          message={t(`call`, {
            query: tool.input?.query,
            filters: tool.input?.filters,
          })}
        />
      );

    case 'output-available':
      return (
        <>
          <ChatToolResultIndicator
            message={t(`result`, {
              count: tool.output.found || 0,
            })}
          />
        </>
      );
  }
};
